import { brand2020 } from './brand2020/brand2020';
import { rebrand2022Theme as brand2022 } from './rebrand2022/rebrand2022';
import { AvailableThemes } from 'fe-lib-theme-types';
import type { Theme } from './types';

export function getThemeByName(themeName: AvailableThemes): Theme {
  switch (themeName) {
    case AvailableThemes.BRAND2020: {
      return brand2020;
    }
    case AvailableThemes.BRAND2022: {
      return brand2022;
    }
  }

  throw new Error(
    `Theme "${themeName}" does not exist. Available themes: ${Object.values(
      AvailableThemes,
    ).join(', ')}`,
  );
}
